type AssetUrlRefetchResult = {
  data?: {
    url?: string;
  };
};

interface OpenAssetUrlOptions {
  fetchAssetUrl: () => Promise<AssetUrlRefetchResult>;
  onUrlResolved: (url: string) => Promise<void>;
}

export const openAssetUrl = async ({
  fetchAssetUrl,
  onUrlResolved,
}: OpenAssetUrlOptions): Promise<void> => {
  const response = await fetchAssetUrl();
  const assetUrl = response.data?.url;

  if (!assetUrl) {
    throw new Error('Missing asset URL');
  }

  await onUrlResolved(assetUrl);
};
